import { lingoDictionary } from '@bookingcom/lingojs-parser';
import { SupportedLocales, localeToBookingLangCode } from '@bookingcom/lingojs-locales';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var defaultCompileOptions = {
    exportMode: 'esmodule',
    lang: SupportedLocales['en-us']
};
var defaultMessagesFuncCompileOptions = {
    syntax: 'es6'
};

// @ts-nocheck
// tslint:disable
// This is autogenerated file, run "yarn plurals" to regenarate it.
// To add more locales, add them in package.json
function ar(n, ord) {
    var s = String(n).split('.'), t0 = Number(s[0]) == n, n100 = t0 && s[0].slice(-2);
    if (ord)
        return 'other';
    return (n == 0) ? 'zero'
        : (n == 1) ? 'one'
            : (n == 2) ? 'two'
                : ((n100 >= 3 && n100 <= 10)) ? 'few'
                    : ((n100 >= 11 && n100 <= 99)) ? 'many'
                        : 'other';
}
function bg(n, ord) {
    if (ord)
        return 'other';
    return (n == 1) ? 'one' : 'other';
}
function ca(n, ord) {
    var s = String(n).split('.'), v0 = !s[1];
    if (ord)
        return ((n == 1
            || n == 3)) ? 'one'
            : (n == 2) ? 'two'
                : (n == 4) ? 'few'
                    : 'other';
    return (n == 1 && v0) ? 'one' : 'other';
}
function cs(n, ord) {
    var s = String(n).split('.'), i = s[0], v0 = !s[1];
    if (ord)
        return 'other';
    return (n == 1 && v0) ? 'one'
        : ((i >= 2 && i <= 4) && v0) ? 'few'
            : (!v0) ? 'many'
                : 'other';
}
function da(n, ord) {
    var s = String(n).split('.'), i = s[0], t0 = Number(s[0]) == n;
    if (ord)
        return 'other';
    return (n == 1 || !t0 && (i == 0
        || i == 1)) ? 'one' : 'other';
}
function de(n, ord) {
    var s = String(n).split('.'), v0 = !s[1];
    if (ord)
        return 'other';
    return (n == 1 && v0) ? 'one' : 'other';
}
function el(n, ord) {
    if (ord)
        return 'other';
    return (n == 1) ? 'one' : 'other';
}
function en(n, ord) {
    var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
    if (ord)
        return (n10 == 1 && n100 != 11) ? 'one'
            : (n10 == 2 && n100 != 12) ? 'two'
                : (n10 == 3 && n100 != 13) ? 'few'
                    : 'other';
    return (n == 1 && v0) ? 'one' : 'other';
}
function es(n, ord) {
    if (ord)
        return 'other';
    return (n == 1) ? 'one' : 'other';
}
function et(n, ord) {
    var s = String(n).split('.'), v0 = !s[1];
    if (ord)
        return 'other';
    return (n == 1 && v0) ? 'one' : 'other';
}
function fi(n, ord) {
    var s = String(n).split('.'), v0 = !s[1];
    if (ord)
        return 'other';
    return (n == 1 && v0) ? 'one' : 'other';
}
function fr(n, ord) {
    if (ord)
        return (n == 1) ? 'one' : 'other';
    return (n >= 0 && n < 2) ? 'one' : 'other';
}
function he(n, ord) {
    var s = String(n).split('.'), i = s[0], v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1);
    if (ord)
        return 'other';
    return (n == 1 && v0) ? 'one'
        : (i == 2 && v0) ? 'two'
            : (v0 && (n < 0
                || n > 10) && t0 && n10 == 0) ? 'many'
                : 'other';
}
function hi(n, ord) {
    if (ord)
        return (n == 1) ? 'one'
            : ((n == 2
                || n == 3)) ? 'two'
                : (n == 4) ? 'few'
                    : (n == 6) ? 'many'
                        : 'other';
    return (n >= 0 && n <= 1) ? 'one' : 'other';
}
function hr(n, ord) {
    var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
    if (ord)
        return 'other';
    return (v0 && i10 == 1 && i100 != 11
        || f10 == 1 && f100 != 11) ? 'one'
        : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14)
            || (f10 >= 2 && f10 <= 4) && (f100 < 12
                || f100 > 14)) ? 'few'
            : 'other';
}
function hu(n, ord) {
    if (ord)
        return ((n == 1
            || n == 5)) ? 'one' : 'other';
    return (n == 1) ? 'one' : 'other';
}
function id(n, ord) {
    if (ord)
        return 'other';
    return 'other';
}
function is(n, ord) {
    var s = String(n).split('.'), i = s[0], t0 = Number(s[0]) == n, i10 = i.slice(-1), i100 = i.slice(-2);
    if (ord)
        return 'other';
    return (t0 && i10 == 1 && i100 != 11
        || !t0) ? 'one' : 'other';
}
function it(n, ord) {
    var s = String(n).split('.'), v0 = !s[1];
    if (ord)
        return ((n == 11 || n == 8 || n == 80
            || n == 800)) ? 'many' : 'other';
    return (n == 1 && v0) ? 'one' : 'other';
}
function ja(n, ord) {
    if (ord)
        return 'other';
    return 'other';
}
function ka(n, ord) {
    var s = String(n).split('.'), i = s[0], i100 = i.slice(-2);
    if (ord)
        return (i == 1) ? 'one'
            : (i == 0 || ((i100 >= 2 && i100 <= 20) || i100 == 40 || i100 == 60
                || i100 == 80)) ? 'many'
                : 'other';
    return (n == 1) ? 'one' : 'other';
}
function ko(n, ord) {
    if (ord)
        return 'other';
    return 'other';
}
function lt(n, ord) {
    var s = String(n).split('.'), f = s[1] || '', t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
    if (ord)
        return 'other';
    return (n10 == 1 && (n100 < 11
        || n100 > 19)) ? 'one'
        : ((n10 >= 2 && n10 <= 9) && (n100 < 11
            || n100 > 19)) ? 'few'
            : (f != 0) ? 'many'
                : 'other';
}
function lv(n, ord) {
    var s = String(n).split('.'), f = s[1] || '', v = f.length, t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2), f100 = f.slice(-2), f10 = f.slice(-1);
    if (ord)
        return 'other';
    return (t0 && n10 == 0 || (n100 >= 11 && n100 <= 19)
        || v == 2 && (f100 >= 11 && f100 <= 19)) ? 'zero'
        : (n10 == 1 && n100 != 11 || v == 2 && f10 == 1 && f100 != 11
            || v != 2 && f10 == 1) ? 'one'
            : 'other';
}
function ms(n, ord) {
    if (ord)
        return (n == 1) ? 'one' : 'other';
    return 'other';
}
function nl(n, ord) {
    var s = String(n).split('.'), v0 = !s[1];
    if (ord)
        return 'other';
    return (n == 1 && v0) ? 'one' : 'other';
}
function no(n, ord) {
    if (ord)
        return 'other';
    return (n == 1) ? 'one' : 'other';
}
function pl(n, ord) {
    var s = String(n).split('.'), i = s[0], v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2);
    if (ord)
        return 'other';
    return (n == 1 && v0) ? 'one'
        : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12
            || i100 > 14)) ? 'few'
            : (v0 && i != 1 && (i10 == 0 || i10 == 1)
                || v0 && (i10 >= 5 && i10 <= 9)
                || v0 && (i100 >= 12 && i100 <= 14)) ? 'many'
                : 'other';
}
function pt(n, ord) {
    var s = String(n).split('.'), i = s[0];
    if (ord)
        return 'other';
    return ((i == 0
        || i == 1)) ? 'one' : 'other';
}
function ro(n, ord) {
    var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n, n100 = t0 && s[0].slice(-2);
    if (ord)
        return (n == 1) ? 'one' : 'other';
    return (n == 1 && v0) ? 'one'
        : (!v0 || n == 0
            || (n100 >= 2 && n100 <= 19)) ? 'few'
            : 'other';
}
function ru(n, ord) {
    var s = String(n).split('.'), i = s[0], v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2);
    if (ord)
        return 'other';
    return (v0 && i10 == 1 && i100 != 11) ? 'one'
        : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12
            || i100 > 14)) ? 'few'
            : (v0 && i10 == 0 || v0 && (i10 >= 5 && i10 <= 9)
                || v0 && (i100 >= 11 && i100 <= 14)) ? 'many'
                : 'other';
}
function sk(n, ord) {
    var s = String(n).split('.'), i = s[0], v0 = !s[1];
    if (ord)
        return 'other';
    return (n == 1 && v0) ? 'one'
        : ((i >= 2 && i <= 4) && v0) ? 'few'
            : (!v0) ? 'many'
                : 'other';
}
function sl(n, ord) {
    var s = String(n).split('.'), i = s[0], v0 = !s[1], i100 = i.slice(-2);
    if (ord)
        return 'other';
    return (v0 && i100 == 1) ? 'one'
        : (v0 && i100 == 2) ? 'two'
            : (v0 && (i100 == 3 || i100 == 4)
                || !v0) ? 'few'
                : 'other';
}
function sr(n, ord) {
    var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
    if (ord)
        return 'other';
    return (v0 && i10 == 1 && i100 != 11
        || f10 == 1 && f100 != 11) ? 'one'
        : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14)
            || (f10 >= 2 && f10 <= 4) && (f100 < 12
                || f100 > 14)) ? 'few'
            : 'other';
}
function sv(n, ord) {
    var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
    if (ord)
        return ((n10 == 1
            || n10 == 2) && n100 != 11 && n100 != 12) ? 'one' : 'other';
    return (n == 1 && v0) ? 'one' : 'other';
}
function th(n, ord) {
    if (ord)
        return 'other';
    return 'other';
}
function tl(n, ord) {
    var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1], i10 = i.slice(-1), f10 = f.slice(-1);
    if (ord)
        return (n == 1) ? 'one' : 'other';
    return (v0 && (i == 1 || i == 2 || i == 3)
        || v0 && i10 != 4 && i10 != 6 && i10 != 9
        || !v0 && f10 != 4 && f10 != 6 && f10 != 9) ? 'one' : 'other';
}
function tr(n, ord) {
    if (ord)
        return 'other';
    return (n == 1) ? 'one' : 'other';
}
function uk(n, ord) {
    var s = String(n).split('.'), i = s[0], v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2), i10 = i.slice(-1), i100 = i.slice(-2);
    if (ord)
        return (n10 == 3 && n100 != 13) ? 'few' : 'other';
    return (v0 && i10 == 1 && i100 != 11) ? 'one'
        : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12
            || i100 > 14)) ? 'few'
            : (v0 && i10 == 0 || v0 && (i10 >= 5 && i10 <= 9)
                || v0 && (i100 >= 11 && i100 <= 14)) ? 'many'
                : 'other';
}
function vi(n, ord) {
    if (ord)
        return (n == 1) ? 'one' : 'other';
    return 'other';
}
function zh(n, ord) {
    if (ord)
        return 'other';
    return 'other';
}

var plurals = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ar: ar,
    bg: bg,
    ca: ca,
    cs: cs,
    da: da,
    de: de,
    el: el,
    en: en,
    es: es,
    et: et,
    fi: fi,
    fr: fr,
    he: he,
    hi: hi,
    hr: hr,
    hu: hu,
    id: id,
    is: is,
    it: it,
    ja: ja,
    ka: ka,
    ko: ko,
    lt: lt,
    lv: lv,
    ms: ms,
    nl: nl,
    no: no,
    pl: pl,
    pt: pt,
    ro: ro,
    ru: ru,
    sk: sk,
    sl: sl,
    sr: sr,
    sv: sv,
    th: th,
    tl: tl,
    tr: tr,
    uk: uk,
    vi: vi,
    zh: zh
});

var stringify = JSON.stringify;
function arg(argName) {
    return "getArg(".concat(stringify(argName), ", args)");
}
var characterIndex = 0;
// No lowercase vowels (or y) to prevent generating function names using reserved words
var FUNCTION_CHARS = "_bcdfghjklmnpqrstuvwxzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function getUniqueFunctionName() {
    var dividend = ++characterIndex;
    var name = "";
    while (dividend > 0) {
        var modulo = (dividend - 1) % FUNCTION_CHARS.length;
        dividend = Math.floor((dividend - modulo) / FUNCTION_CHARS.length);
        name = FUNCTION_CHARS[modulo] + name;
    }
    return name;
}
function compileTextElement(element) {
    return "".concat(stringify(element.value));
}
function compileOptions(options, messagesFuncCompileOptions, optimise) {
    if (messagesFuncCompileOptions === void 0) { messagesFuncCompileOptions = defaultMessagesFuncCompileOptions; }
    var optionsStrings = options.map(function (option) {
        var body = compileMessageRoot(option.value, messagesFuncCompileOptions, optimise && {
            parentName: optimise.parentName + "/" + option.selector,
            functions: optimise.functions
        });
        var name = stringify(option.selector);
        var es6 = messagesFuncCompileOptions.syntax === 'es6';
        if (optimise) {
            var functionName = getUniqueFunctionName();
            if (es6) {
                optimise.functions.push("const ".concat(functionName, "=(args)=>").concat(body, ";"));
            }
            else {
                optimise.functions.push("function ".concat(functionName, "(args){return ").concat(body, ";};"));
            }
            return "".concat(name, ":").concat(functionName);
        }
        if (es6) {
            return "".concat(name, ":() => ").concat(body);
        }
        return "".concat(name, ": function() { return ").concat(body, "; }");
    });
    return "{".concat(optionsStrings.join(','), "}");
}
function compileRecursiveElement$1(element, messagesFuncCompileOptions) {
    if (messagesFuncCompileOptions === void 0) { messagesFuncCompileOptions = defaultMessagesFuncCompileOptions; }
    if (messagesFuncCompileOptions.syntax === 'es6') {
        return "getMessage(".concat(stringify(element.meta.recursiveTag), ")(Object.assign({}, args, {item: ").concat(arg(element.id), "}))");
    }
    return "getMessage(".concat(stringify(element.meta.recursiveTag), ")((function(args, itemValue) { var obj = {}; for (var key in args) { obj[key] = args[key]; } obj.item = itemValue; return obj; })(args, ").concat(arg(element.id), "))");
}
function compileArgumentElement$1(element, messagesFuncCompileOptions, optimise) {
    if (messagesFuncCompileOptions === void 0) { messagesFuncCompileOptions = defaultMessagesFuncCompileOptions; }
    if (element.format === null) {
        return arg(element.id);
    }
    if (typeof element.meta === 'object' && element.meta.recursiveTag) {
        return compileRecursiveElement$1(element, messagesFuncCompileOptions);
    }
    switch (element.format.type) {
        case 'selectFormat': {
            return "selectItem(args, ".concat(compileOptions(element.format.options, messagesFuncCompileOptions, optimise), ")");
        }
        case 'pluralFormat': {
            return "selectPlural(args, ".concat(compileOptions(element.format.options, messagesFuncCompileOptions, optimise), ")");
        }
        default:
            throw new Error('Message element does not have a valid format type');
    }
}
function compileMessageRoot(ast, compileOptions, optimise) {
    var elements = ast.elements.map(function (element) {
        switch (element.type) {
            case 'messageTextElement':
                return compileTextElement(element);
            case 'argumentElement':
                return compileArgumentElement$1(element, compileOptions, optimise);
            default:
                throw new Error('Message element does not have a valid type');
        }
    });
    if (elements.length > 0) {
        var glue = (optimise) ? '+' : ' + ';
        return elements.join(glue);
    }
    return '""';
}
function compileMessage(ast, compileOptions, optimise) {
    if (compileOptions === void 0) { compileOptions = defaultMessagesFuncCompileOptions; }
    var body = compileMessageRoot(ast, compileOptions, optimise);
    if (compileOptions.optimiseFunctions) {
        if (compileOptions.syntax === 'es6') {
            return "(args)=>".concat(body);
        }
        return "function(args){return ".concat(body, "}");
    }
    if (compileOptions.syntax === 'es6') {
        return "(args) => ".concat(body);
    }
    return "function(args) { return ".concat(body, "; }");
}
function compileMessageType(tagName, ast) {
    // Get all argument names
    var args = ast.elements
        .filter(function (e) { return e.type === 'argumentElement'; })
        .map(function (e) { return e.id; });
    // No need for argument type if no arguments exist (num_exceptions counts as arg here)
    if (args.length === 0)
        return;
    var hasNumExceptions = args.indexOf('num_exception') >= 0;
    var variables = hasNumExceptions
        ? args.filter(function (a) { return a !== 'num_exception'; })
        : args;
    var variablesWithoutDuplicates = new Set(variables);
    return [
        '{',
        "  tagName: '".concat(tagName, "';"),
        hasNumExceptions && '  num_exception: number;',
        variablesWithoutDuplicates.size > 0 &&
            "  variables: { ".concat(Array.from(variablesWithoutDuplicates)
                .map(function (k) { return "".concat(k, ": string | number;"); })
                .join(' '), " }"),
        '}',
    ]
        .filter(Boolean)
        .join('\n');
}
function makeMessagesObject(dictionary, compileOptions) {
    if (compileOptions === void 0) { compileOptions = defaultMessagesFuncCompileOptions; }
    var signature = "const messages = (selectItem, selectPlural, getArg, getMessage) =>";
    if (compileOptions.optimiseFunctions) {
        var functions = [];
        var messages = messagesToString(dictionary, compileOptions, functions);
        return "".concat(signature, "{").concat(functions.join(''), "\nreturn {").concat(messages, "}\n}");
    }
    else {
        var messages = messagesToString(dictionary, compileOptions);
        return "".concat(signature, " ({\n").concat(messages, "});");
    }
}
function makeMessageTypes(dictionary) {
    var types = '';
    var messageTypes = [];
    var messageKeys = Object.keys(dictionary._messages);
    messageKeys.forEach(function (key) {
        var msgAst = dictionary._messages[key];
        var messageType = compileMessageType(key, msgAst);
        if (messageType)
            messageTypes.push(messageType);
    });
    types += "export type CopyTags = \n  \"".concat(messageKeys.join('"\n  | "'), "\"; \n\n");
    types += "export type CopyTagArgs = ".concat(messageTypes
        .filter(Boolean)
        .join(' |\n'), "; \n\n");
    return types;
}
function generateCopyExperimentDictionary(lang, copyExperiments) {
    var e_1, _a, e_2, _b;
    var copyExperimentDictionary = {};
    try {
        for (var copyExperiments_1 = __values(copyExperiments), copyExperiments_1_1 = copyExperiments_1.next(); !copyExperiments_1_1.done; copyExperiments_1_1 = copyExperiments_1.next()) {
            var experiment = copyExperiments_1_1.value;
            try {
                for (var _c = (e_2 = void 0, __values(experiment.copy_tags)), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var copyTags = _d.value;
                    if (!experiment.all_languages &&
                        (experiment.languages.length === 0 || !experiment.languages.includes(localeToBookingLangCode[lang]))) {
                        continue;
                    }
                    copyExperimentDictionary[copyTags[0]] = {
                        variants: copyTags,
                        experiment_hash: experiment.experiment_hash,
                        actions: experiment.actions,
                        countries: experiment.countries,
                        site_types: experiment.site_types,
                        segment: experiment.segment,
                        all_actions: experiment.all_actions,
                        all_countries: experiment.all_countries
                    };
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (copyExperiments_1_1 && !copyExperiments_1_1.done && (_a = copyExperiments_1.return)) _a.call(copyExperiments_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return copyExperimentDictionary;
}
function makeCopyExperimentFunc(copyExperiments, lang) {
    var copyExperimentDictionary = generateCopyExperimentDictionary(lang, copyExperiments);
    if (!Object.keys(copyExperimentDictionary).length) {
        return 'const getCopyExperimentData = (copyTag, siteType, action, segment, country) => null;';
    }
    return "const getCopyExperimentData = (copyTag, siteType, action, segment, country) => {\n  const exp = ".concat(JSON.stringify(copyExperimentDictionary), "[copyTag];\n\n  if (!exp) {\n    return null;\n  }\n\n  if (segment && exp.segment && exp.segment === segment) {\n    return null;\n  }\n\n  if (siteType && exp.site_types.length && exp.site_types.indexOf(siteType) === -1) {\n    return null;\n  }\n\n  if (!exp.all_actions && action && exp.actions.length && exp.actions.indexOf(action) === -1) {\n    return null;\n  }\n\n  if (!exp.all_countries && country && exp.countries.length && exp.countries.indexOf(country) === -1) {\n    return null;\n  }\n\n  return {\n    experimentHash: exp.experiment_hash,\n    variants: exp.variants\n  };\n};");
}
function getPluralFunction(lang) {
    var plural = plurals[lang] || plurals[lang.slice(0, 2)];
    if (!plural) {
        throw new Error("Language ".concat(lang, " is not supported by make-plural"));
    }
    return plural;
}
function getMessagesFunction$1(dictionary, compileOptions, dictionaryOptions) {
    if (compileOptions === void 0) { compileOptions = { syntax: 'es5' }; }
    var parsedDictionary = lingoDictionary(dictionary, dictionaryOptions);
    var body;
    if (compileOptions.optimiseFunctions) {
        var functions = [];
        var messages = messagesToString(parsedDictionary, compileOptions, functions);
        body = "".concat(functions.join(''), "return {").concat(messages, "}");
    }
    else {
        body = "return {\n".concat(messagesToString(parsedDictionary, compileOptions), " }");
    }
    // @ts-ignore
    // tslint:disable-next-line:no-function-constructor-with-string-args
    return new Function('selectItem', 'selectPlural', 'getArg', 'getMessage', body);
}
function messagesToString(dictionary, compileOptions, functions) {
    characterIndex = 0;
    var messages = Object.keys(dictionary._messages).map(function (key) {
        var msgAst = dictionary._messages[key];
        var name = stringify(key);
        if (compileOptions.optimiseFunctions && functions) {
            var functionName = getUniqueFunctionName();
            var optimise = {
                parentName: functionName,
                functions: functions,
            };
            var keyword = (compileOptions.syntax === 'es6') ? 'const' : 'var';
            functions.push("".concat(keyword, " ").concat(functionName, "=").concat(compileMessage(msgAst, compileOptions, optimise), ";"));
            return "  ".concat(name, ": ").concat(functionName);
        }
        return "  ".concat(name, ": ").concat(compileMessage(msgAst, compileOptions));
    }).join(',\n');
    return "".concat(messages, "\n");
}
function getMessagesObject(dictionary, options, dictionaryOptions) {
    var parsedDictionary = lingoDictionary(dictionary, dictionaryOptions);
    return {
        messagesObj: makeMessagesObject(parsedDictionary, options),
        parsedDictionary: parsedDictionary,
    };
}
function prepareModule(dictionary, copyExperiments, options) {
    if (options === void 0) { options = defaultCompileOptions; }
    var opts = __assign(__assign({}, defaultCompileOptions), options);
    var lang = opts.lang, exportMode = opts.exportMode, exportTypes = opts.exportTypes, _a = opts.useExperiments, useExperiments = _a === void 0 ? false : _a, _b = opts.skipPluralsDefinition, skipPluralsDefinition = _b === void 0 ? false : _b;
    var messagesOptions = (opts.messagesOptions) ? __assign(__assign({}, defaultMessagesFuncCompileOptions), opts.messagesOptions) : defaultMessagesFuncCompileOptions;
    var plural = skipPluralsDefinition ? null : getPluralFunction(lang);
    var pluralFunc = plural ? "const plural = ".concat(plural.toString(), ";") : '';
    var _c = getMessagesObject(dictionary, messagesOptions), messagesObj = _c.messagesObj, parsedDictionary = _c.parsedDictionary;
    var typeDefs = exportTypes && makeMessageTypes(parsedDictionary);
    var copyExperimentFunc = useExperiments ? "\n\n".concat(makeCopyExperimentFunc(copyExperiments, lang)) : '';
    var exportedObj = useExperiments
        ? skipPluralsDefinition
            ? '{ messages, getCopyExperimentData }'
            : '{ messages, plural, getCopyExperimentData }'
        : skipPluralsDefinition
            ? '{ messages }'
            : '{ messages, plural }';
    var result = "/* eslint-disable */\n/* tslint:disable */\n/* istanbul ignore file */\n".concat(pluralFunc, "\n\n").concat(messagesObj).concat(copyExperimentFunc, "\n\n").concat(exportMode === 'esmodule'
        ? "export ".concat(exportedObj, ";")
        : "module.exports = ".concat(exportedObj, ";"));
    return {
        module: result,
        types: typeDefs
    };
}

// assign polyfill, as IE11 does not support `Object.assign`
function assign(target) {
    var rest = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        rest[_i - 1] = arguments[_i];
    }
    var to = Object(target);
    for (var i = 1; i < arguments.length; i++) {
        var nextSource = arguments[i];
        if (nextSource === undefined || nextSource === null) {
            continue;
        }
        var keysArray = Object.keys(Object(nextSource));
        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) {
                to[nextKey] = nextSource[nextKey];
            }
        }
    }
    return to;
}
var compileMessageTextElement = function (value) {
    return function () { return value; };
};
var compileArgumentElement = function (getArg, id) {
    return function (args) { return getArg(id, args); };
};
var compileRecursiveElement = function (element, getArg, getMessage) {
    return function (args) { return getMessage(element.meta.recursiveTag)(assign({}, args, { item: getArg(element.id, args) })); };
};
function messagesToFunctions(dictionary, selectItem, selectPlural, getArg, getMessage) {
    var compileOptions = function (options) {
        return options.reduce(function (acc, option) {
            acc[option.selector] = compileMessageFormatPattern(option.value);
            return acc;
        }, {});
    };
    var mapElements = function (element) {
        switch (element.type) {
            case 'messageTextElement':
                return compileMessageTextElement(element.value);
            case 'argumentElement':
                if (element.format === null) {
                    return compileArgumentElement(getArg, element.id);
                }
                else {
                    if (typeof element.meta === 'object' && element.meta.recursiveTag) {
                        return compileRecursiveElement(element, getArg, getMessage);
                    }
                    switch (element.format.type) {
                        case 'selectFormat': {
                            return function (args) { return selectItem(args, compileOptions(element.format.options)); };
                        }
                        case 'pluralFormat': {
                            return function (args) { return selectPlural(args, compileOptions(element.format.options)); };
                        }
                        default:
                            throw new Error('Message element does not have a valid format type');
                    }
                }
            default:
                throw new Error('Message element does not have a valid type');
        }
    };
    var compileMessageFormatPattern = function (ast) {
        if (ast.elements.length > 0) {
            var elements_1 = ast.elements.map(mapElements);
            return elements_1.length === 1 ? elements_1[0] : function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return elements_1.map(function (e) { return e.apply(void 0, __spreadArray([], __read(args), false)); }).join('');
            };
        }
        return function () { return ''; };
    };
    return Object.keys(dictionary._messages).reduce(function (acc, key) {
        var msgAst = dictionary._messages[key];
        acc[key] = compileMessageFormatPattern(msgAst);
        return acc;
    }, {});
}
function getMessagesFunction(dictionary, options) {
    var parsedDictionary = lingoDictionary(dictionary, options);
    return function messagesFunction(selectItem, selectPlural, getArg, getMessage) {
        return messagesToFunctions(parsedDictionary, selectItem, selectPlural, getArg, getMessage);
    };
}

export { defaultCompileOptions, getMessagesFunction$1 as getMessagesFunction, getMessagesFunction as getMessagesFunctionRuntime, getPluralFunction, prepareModule };
//# sourceMappingURL=index.es.js.map
